import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TAppState } from '../../redux';
import {
  removeContentWindow,
  setIsContentWindowOpen,
  updateContentWindowGeometry,
} from '../../redux/contentWindows';

import { ContentWindowContainer } from './ContentWindowContainer';
import { TWindowGeometryPatch } from './types';

export function ContentWindowsKeeper() {
  const dispatch = useDispatch();
  const { list, settings } = useSelector((state: TAppState) => state.contentWindows);
  const projectId = useSelector((state: TAppState) => state.editor.project?.id);

  // Каррирование всё равно даёт новую функцию на рендер, поэтому debounce скролла
  // защищён не отсюда, а стабильным ref внутри ContentWindow. useCallback здесь —
  // только чтобы не плодить лишние ссылки на пустом месте.
  const handleGeometryChange = useCallback(
    (nodeId: string) => (patch: TWindowGeometryPatch) =>
      dispatch(updateContentWindowGeometry({ nodeId, ...patch })),
    [dispatch],
  );

  // Геометрия уже в сторе — сворачивание больше не должно её переносить.
  const handleCollapseClick = useCallback(
    (nodeId: string) => () => dispatch(setIsContentWindowOpen({ nodeId, isOpen: false })),
    [dispatch],
  );

  const handleCloseClick = useCallback(
    (nodeId: string) => () => dispatch(removeContentWindow({ nodeIdToRemove: nodeId })),
    [dispatch],
  );

  return (
    <>
      {list.map((nodeId) => {
        const certainSettings = settings[nodeId];
        if (!certainSettings.isOpen) {
          return null;
        }

        return (
          <ContentWindowContainer
            size={certainSettings.size}
            coords={certainSettings.coords}
            scrollPercent={certainSettings.scrollPercent}
            // Ключ с projectId: скролл применяется только при монтировании, а два
            // проекта могут делить id заметки (импорт копии). С ключом из одного
            // nodeId React переиспользовал бы компонент и показал чужой скролл.
            key={`${projectId}:${nodeId}`}
            nodeId={nodeId}
            onGeometryChange={handleGeometryChange(nodeId)}
            onCollapseClick={handleCollapseClick(nodeId)}
            onCloseClick={handleCloseClick(nodeId)}
          />
        );
      })}
    </>
  );
}
